import Api from "../../api";
import auth from "../../auth/service";

import { Application, ApplicationContent, ApplicationReply, Call, CallResult, Configuration, Input, AuxiliaryFile } from "./models.jsx";

const callsUrl = "calls";
const openCallsUrl = callsUrl + "/open" ;
const configurationsUrl = "configurations";
const applicationsUrl = "requests";
const applicationRepliesUrl = "replies";
const callState = "/state";
const inputsUrl = "/inputs";
const filesUrl = "/files";
const resultsUrl = "/results";


class CallsApi extends Api {

	getPage(startItem, endItem, startDate, endDate, keyword, callback) {
	    var url = this.baseUrl + callsUrl;
	    if (keyword != null && keyword.length > 0)
	     	url += "?keyword=" + keyword;
	     
	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem},
	    	params: { startDate: startDate, endDate: endDate }
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new Call(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	getOpenPage(startItem, endItem, callback) {
		var url = this.baseUrl + openCallsUrl;
	     
	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem}
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new Call(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}
	
	get(callId, callback) {
		var url = this.baseUrl + callsUrl + "/" + callId;
		this.client.get(url)
			.then((response) => {
				callback({
					result: new Call(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	delete(callId, callback) {
		var url = this.baseUrl + callsUrl + "/" + callId;
		this.client.delete(url)
			.then((response) => {
				callback({
					result: response.data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	create(call, callback) {
		var url = this.baseUrl + callsUrl;
		this.client.post(url, call)
			.then((response) => {
				callback({
					result: new Call(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	changeState(call, state, callback) {
		var url = this.baseUrl + callsUrl + "/" + call.id + callState;

		this.client.put(url,state,{ headers: {'content-type': 'application/json'} })
			.then((response) => {
				callback({
					result: new Call(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	update(callId, data, callback) {
		var url = this.baseUrl + callsUrl + "/" + callId;

		this.client.put(url, data)
			.then((response) => {
				callback({
					result: new Call(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}
}

class CallResultApi extends Api {

	getFile(callId, resultId, fileId, callbacks) {
	    let url = this.baseUrl + callsUrl + "/" + callId + resultsUrl + "/" + resultId + filesUrl + "/" + fileId;
	    this.loadBinary(url,callbacks);
	}

	create(callId, files, callbacks) {
		let url = this.baseUrl + callsUrl + "/" + callId + resultsUrl;

		this.client.post(url, files, {
		    onUploadProgress: data => {
		      callbacks.onUpdateProgress(Math.round((100 * data.loaded) / data.total));
		    }})
			.then((response) => {
				callbacks.result({
					result: new CallResult(response.data), 
					error: null
				}) 
		    }).catch((error) => {
				callbacks.result({
					result: null, 
					error: this.extractError(error)
				}) 
		    })
		}
}

class ConfigurationApi extends Api {
	
	get(configurationId, callback) {
 		var url = this.baseUrl + configurationsUrl + "/" + configurationId;
		this.client.get(url)
			.then((response) => {
				callback({
					result: new Configuration(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	getAll(callback) {
	    var url = this.baseUrl + configurationsUrl;
	     
	    this.client.get(url)
		    .then((response) => {
				var rangeHeader = response.headers["range"];
				var total = parseInt(rangeHeader.split("/")[1]);

				var data = [];
				for (var index = 0; index < response.data.length; index++) {
					data.push(new Configuration(response.data[index]));
				}

		    	callback({ 
		    		result: { data: data, total: total }, 
		    		error: null
		    	});
		    }).catch((error) => {
		    	callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
		    });
	}

	getPage(startItem, endItem, keyword, callback) {
	    var url = this.baseUrl + configurationsUrl;
	    if (keyword != null && keyword.length > 0)
	     	url += "?keyword=" + keyword;
	     
	    this.client.get(url, { headers: {"Range": "items=" + startItem + "-" + endItem} })
		    .then((response) => {
				var rangeHeader = response.headers["range"];
				var total = parseInt(rangeHeader.split("/")[1]);

				var data = [];
				for (var index = 0; index < response.data.length; index++) {
					data.push(new Configuration(response.data[index]));
				}

		    	callback({ 
		    		result: { data: data, total: total }, 
		    		error: null
		    	});
		    }).catch((error) => {
		    	callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
		    });
	}

	create(newConfiguration, callback) {
	    var url = this.baseUrl + configurationsUrl;
		this.client.post(url, newConfiguration)
			.then((response) => {
				callback({
					result: new Configuration(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	delete(configurationId, callback) {
 		var url = this.baseUrl + configurationsUrl + "/" + configurationId;
		this.client.delete(url)
			.then((response) => {
				callback({
					result: response.data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	update(updatedConfiguration, callback) {
 		var url = this.baseUrl + configurationsUrl + "/" + updatedConfiguration.id;

	 	this.client.put(url, updatedConfiguration)
	     	.then((response) => {
	     		callback({
					result: response.data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}
}

class InputsApi extends Api {

	create(newInput, callback) {
	    let url = this.baseUrl + configurationsUrl + "/" + newInput.configurationId + inputsUrl;
		this.client.post(url, newInput)
			.then((response) => {
				callback({
					result: new Input(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	delete(configurationId, inputId, callback) {
	    let url = this.baseUrl + configurationsUrl + "/" + configurationId + inputsUrl + "/" + inputId ;
		this.client.delete(url)
			.then((response) => {
				var data = [];
				for (var index = 0; index < response.data.length; index++)
					data.push(new Input(response.data[index]));
				callback({
					result: data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	move(configurationId, inputId, newPosition, callback) {
  	    let url = this.baseUrl + configurationsUrl + "/" + configurationId + inputsUrl + "/" + inputId + "/move";
	    this.client.post(url, newPosition, { headers: {'content-type': 'application/json'} } )
	        .then((response) => {
				var data = [];
				for (var index = 0; index < response.data.length; index++)
					data.push(new Input(response.data[index]));
				callback({
					result: data,
					error: null
				});
	        }).catch((error) => {
	          	callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
	        });
	}

	update(newInput, callback) {
		let url = this.baseUrl + configurationsUrl + "/" + newInput.configurationId + inputsUrl + "/" + newInput.id;
 		this.client.put(url, newInput)
	        .then((response) => {
				callback({
					result: response.data,
					error: null
				});
	        }).catch((error) => {
	          	callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
	        });
	}
}

class AuxiliaryFilesApi extends Api {

	delete(configurationId, inputId, auxiliaryFileId, callback) {
	    let url = this.baseUrl + configurationsUrl + "/" + configurationId + inputsUrl + "/" + inputId + filesUrl + "/" + auxiliaryFileId;
		this.client.delete(url)
			.then((response) => {
				callback({
					result: new Input(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	get(configurationId, inputId, auxiliaryFileId, callbacks) {
	    let url = this.baseUrl + configurationsUrl + "/" + configurationId + inputsUrl + "/" + inputId + filesUrl + "/" + auxiliaryFileId;
	    this.loadBinary(url,callbacks);
	}

	create(configurationId, inputId, binary, callbacks) {
	    let url = this.baseUrl + configurationsUrl + "/" + configurationId + inputsUrl + "/" + inputId + filesUrl;
	    this.uploadBinary(url,binary, {
	    	onUpdateProgress: callbacks.onUpdateProgress,
	    	success: (result) => { 
	    		callbacks.result({result: new AuxiliaryFile(result), error: null}) 
	    	},
			error: (error) => { 
				callbacks.result({result: null, error: error}) 
			}
	    });
	}
}

class ApplicationApi extends Api {

	create(callId, callback) {
		let application = new Application();
		application.creation();
		application.callId = callId;
		application.extensionDate = null;

	    let url = this.baseUrl + applicationsUrl;

		this.client.post(url, application)
			.then((response) => {
				callback({
					result: new Application(response.data.request),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	get(applicationId, callback) {
		var url = this.baseUrl + applicationsUrl + "/" + applicationId;

		this.client.get(url)
			.then((response) => {
				callback({
					result: new Application(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	getPage(startItem, endItem, callback) {
	    var url = this.baseUrl + applicationsUrl;
	     
	    let userId = auth.getUser().id

	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem},
	    	params: { "userId": userId }
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new Application(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
			callback({
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}


	sendApplication(application, callback) {

	    var newApplication = {
	      id: application.id,
	      creationTime: application.creationTime,
	      userId: application.userId,
	      serviceId: application.serviceId,
	      lastUpdate: application.lastUpdate,
	      state: 1, // Estado enviado
	      callId: application.callId,
	      extensionDate: application.extensionDate,
	    }

		var url = this.baseUrl + applicationsUrl + "/" + (application.id);

	    this.client.put(url, newApplication)
	    	.then((response) => {
				callback({
					result: new Application(response.data.request),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}
}

class ApplicationReplyApi extends Api {

	create(applicationId, replyData, callback) {

		let reply = new ApplicationReply();
		reply.creation();

		reply.requestId = applicationId;
		reply.code = replyData.code;
		reply.message = replyData.message;
		reply.extensionDate = replyData.extensionDate;

	    let url = this.baseUrl + applicationsUrl + "/" + applicationId + "/" + applicationRepliesUrl ;

		this.client.post(url, reply)
			.then((response) => {
				callback({
					result: new ApplicationReply(response.data.reply),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

}

class ApplicationContentApi extends Api {

	createFile(applicationId, inputId, binary, callbacks) {
		let url = this.baseUrl + applicationsUrl + "/" + applicationId + inputsUrl + "/" + inputId + filesUrl;
	    this.uploadBinary(url, binary, {
	    	onUpdateProgress: callbacks.onUpdateProgress,
	    	success: (result) => { 
	    		callbacks.result({result: new ApplicationContent(result), error: null}) 
	    	},
			error: (error) => { 
				callbacks.result({result: null, error: error}) 
			}
	    });
	}

	deleteFile(applicationId, inputId, fileId, callback) {
		let url = this.baseUrl + applicationsUrl + "/" + applicationId + inputsUrl + "/" + inputId + filesUrl + "/" + fileId;
		this.client.delete(url)
			.then((response) => {
				callback({
					result: new ApplicationContent(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	getFile(applicationId, inputId, fileId, callbacks) {
		let url = this.baseUrl + applicationsUrl + "/" + applicationId + inputsUrl + "/" + inputId + filesUrl + "/" + fileId;
 		this.loadBinary(url,callbacks);
	}

}

class CallsServiceApi{

	constructor(baseUrl) {
		this.configurations = new ConfigurationApi(baseUrl);
		this.inputs = new InputsApi(baseUrl);
		this.auxiliaryFiles = new AuxiliaryFilesApi(baseUrl);
		this.calls = new CallsApi(baseUrl);
		this.callResults = new CallResultApi(baseUrl);
		this.applications = new ApplicationApi(baseUrl);
		this.applicationReplies = new ApplicationReplyApi(baseUrl);
		this.applicationContents = new ApplicationContentApi(baseUrl);
	}

}


export default CallsServiceApi;